var _path, _g, _path2, _path3, _path4, _path5, _polygon, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _ellipse, _ellipse2, _polygon2, _polygon3, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _ellipse3, _ellipse4, _path30, _path31, _path32, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _ellipse12, _path33, _path34, _path35;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTransparencyAndComplianceSecondary(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 990.93,
    height: 799.33,
    viewBox: "0 0 990.93 799.33",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "judge_katerina_limpitsouni") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1094,514.11c-3.55-31.86-13.88-62-27.35-88.93-30.4-60.85-76.47-106.25-126.27-138.77-.48-.32-1-.62-1.45-.93A55.72,55.72,0,0,0,950.42,263c15.32-62.77-88-141.89-230.7-176.7C605.2,58.4,500.1,67.48,455.12,104.6,350.2,98,240.74,162.56,168,262c-26,35.59-48,77.63-57.65,125.16-11.74,57.56-4.72,119.51,11.75,175.06,12.69,42.78,31.23,82.86,54.54,117.19q2.49,3.66,5.05,7.24,4.41,6.17,9,12c19.2,24.45,41.06,45.21,65.1,60.92a208.26,208.26,0,0,0,43.69,21.8c41,14.68,85,15.29,125.52,0a175.76,175.76,0,0,0,19.84-8.91q5.34-2.79,10.56-6c6.71-4.12,13.3-8.72,19.84-13.5,9.07-6.64,18-13.64,27.11-20.18l.78-.57c10.7-7.68,21.53-14.71,32.82-19.77a90.34,90.34,0,0,1,23.66-7.17,83.47,83.47,0,0,1,36.13,2.81c2.22.64,4.44,1.37,6.64,2.17a142.32,142.32,0,0,1,20.72,9.61c28.84,16,56.44,41.51,84.76,61.51,4,2.86,8.11,5.61,12.19,8.2,36.13,22.93,75.87,34.11,115.19,44.95,44.58,12.3,91.76,24.24,134.89,5.09,25-11.09,46.65-32.12,64-58.24a258.6,258.6,0,0,0,19.94-36.19q4.23-9.33,7.91-19c14.26-37.5,22.55-78.7,28.27-120C1094.49,575.78,1097.37,544.65,1094,514.11Z",
    transform: "translate(-104.53 -50.34)",
    fill: "#6ba6c7",
    opacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M415.91,583.52c.31.89.63,1.75,1,2.59q9.89-7.75,19.16-16a18.55,18.55,0,0,0,8.7-8c1.78-1.68,3.55-3.4,5.3-5.11a26.05,26.05,0,0,0-2.43-2.39c-5.92-5.19-13.24-7.37-19.93-5.16s-11.26,8.32-12.93,16A34.44,34.44,0,0,0,415.91,583.52Z",
    transform: "translate(-104.53 -50.34)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.93,550.3a34.46,34.46,0,0,0,9.83,15.15c5.92,5.17,13.23,7.36,19.93,5.14.46-.16.9-.33,1.36-.51a18.55,18.55,0,0,0,8.7-8,25.86,25.86,0,0,0,2.87-7.5,35.86,35.86,0,0,0-11-33.22c-5.93-5.19-13.24-7.37-19.93-5.16s-11.26,8.32-12.93,16A34.44,34.44,0,0,0,404.93,550.3Z",
    transform: "translate(-104.53 -50.34)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 414.71,
    cy: 510.2,
    rx: 21.87,
    ry: 28.63,
    transform: "translate(-243.72 105.63) rotate(-18.29)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 403.73,
    cy: 476.99,
    rx: 21.87,
    ry: 28.63,
    transform: "translate(-233.85 100.5) rotate(-18.29)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 392.75,
    cy: 443.77,
    rx: 21.87,
    ry: 28.63,
    transform: "translate(-223.98 95.38) rotate(-18.29)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.32,190.75a106.12,106.12,0,0,0,4-13.94l-57.52,9.08,59.15-19.07a105,105,0,0,0-24.16-79.43l-65.58,67.24,55.26-77.8A104.75,104.75,0,1,0,239,242.43a104.64,104.64,0,0,0-5.35,21.89l83,13.38-83.89-.38a104.8,104.8,0,0,0,46.91,88.09A104.74,104.74,0,1,0,436,313.72a104.74,104.74,0,0,0-40.65-123Z",
    transform: "translate(-104.53 -50.34)",
    fill: "#6ba6c7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238,311a104.32,104.32,0,0,0,41.61,54.45A104.74,104.74,0,1,0,436,313.72C443.71,292.39,234.34,299.79,238,311Z",
    transform: "translate(-104.53 -50.34)",
    opacity: 0.1
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M492.62,300.54c-2.49-5.08-3.42-10.81-4.32-16.43-5.28-33.18-10.22-69,4.12-99.07,2.26-4.73,5-9.33,9-12.56,4.28-3.45,9.59-5.09,14.55-7.33,14.4-6.48,26-18.11,38.66-27.76s27.94-17.7,43.45-15.24c8,1.27,15.4,5.27,23.16,7.78,21.92,7.1,47.22,2.47,66.91,14.78,7.11,4.45,12.91,10.8,18.61,17.08l25.43,28c6.89,7.58,13.91,15.35,18.08,24.85s5.05,21.21-.26,30.07c-2.67,4.47-6.89,8.34-7.35,13.59-.5,5.7,3.64,10.6,5.15,16.1,4,14.53-10.67,27-24.05,32.74-40.43,17.3-84.91,15.31-127.71,14.6C564.18,321.19,511,337.92,492.62,300.54Z",
    transform: "translate(-104.53 -50.34)",
    fill: "#3f3d56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M564.52,372.45c-2.81,6.71-8.85,11.45-14.82,15.62s-12.34,8.14-19.53,8.48c12.67,16.29,30,28.27,46.94,40C585,442,593,447.44,602,450.52c8.26,2.82,17.05,3.52,25.69,4.7,11,1.51,21.95,3.84,33,3.38,19.69-.82,38.52-10.75,51.58-25.51s20.54-34,22.56-53.63c-7-.11-13.46-4-19.11-8.24-6.91-5.17-13.39-11.15-17.85-18.54-4.83-8-7-17.28-9.2-26.37-23.31-.7-46.62-1.39-69.94-.94-8.49.16-17,.49-25.28,2.6-7.89,2-24.37,7.16-29.18,14.27-2.77,4.1,0,8.32,1,12.74C566.55,360.79,566.87,366.86,564.52,372.45Z",
    transform: "translate(-104.53 -50.34)",
    fill: "#be6f72"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M564.52,372.45c-2.81,6.71-8.85,11.45-14.82,15.62s-12.34,8.14-19.53,8.48c12.67,16.29,30,28.27,46.94,40C585,442,593,447.44,602,450.52c8.26,2.82,17.05,3.52,25.69,4.7,11,1.51,21.95,3.84,33,3.38,19.69-.82,38.52-10.75,51.58-25.51s20.54-34,22.56-53.63c-7-.11-13.46-4-19.11-8.24-6.91-5.17-13.39-11.15-17.85-18.54-4.83-8-7-17.28-9.2-26.37-23.31-.7-46.62-1.39-69.94-.94-8.49.16-17,.49-25.28,2.6-7.89,2-24.37,7.16-29.18,14.27-2.77,4.1,0,8.32,1,12.74C566.55,360.79,566.87,366.86,564.52,372.45Z",
    transform: "translate(-104.53 -50.34)",
    opacity: 0.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M590.89,400.08c6.67,8.29,13.54,16.75,22.68,22.19,2.79,1.65,5.91,3,9.15,2.89,4.8-.2,8.77-3.62,12.29-6.9a675.29,675.29,0,0,0,50-51.78c4.93-5.69,10-11.62,16.75-14.93a1016.62,1016.62,0,0,1,4.76,165.78,6,6,0,0,1-.7,3c-1.05,1.59-3.25,1.82-5.16,1.89-56.45,2.12-115.16,3.82-166.86-19,3.59-10.65,3-22.17,3.35-33.41.57-18.43,3.77-36.68,8.19-54.55,2.17-8.77,4.64-17.46,7.26-26.1,2.18-7.24,3.84-20,8.71-25.47C572.51,373.69,581.48,388.38,590.89,400.08Z",
    transform: "translate(-104.53 -50.34)",
    fill: "#e3e8f4"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "511.99 376.54 518.99 376.54 536.99 406.54 517.99 453.54 494.99 407.54 511.99 376.54",
    fill: "#3f3d56"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M615.89,474.28a84,84,0,0,1-13.18-31.54c-.7-3.62-1.17-7.31-2.45-10.77-1.9-5.13-5.48-9.43-8.71-13.86a122.9,122.9,0,0,1-22.45-55.72c-1.24-9.14-2.07-19.61-9.45-25.14-4.64-3.47-10.82-4-16.62-3.9a93.62,93.62,0,0,0-60.54,24.23,100,100,0,0,1-8.75,7.72,56.15,56.15,0,0,1-10,5.44c-8.86,4-18.12,7.32-27.77,8.33a30.44,30.44,0,0,0-7.32,1.21c-2.88,1-5.25,3.11-7.68,5a70.86,70.86,0,0,1-26.19,12.64,527.27,527.27,0,0,0-31,96.71c-1.81,8.25-3.43,16.56-5.9,24.64-3.41,11.2-8.43,21.88-11.78,33.1-13.32,44.65.67,93.29-8.3,139l481.06.66c-7.56-11.73-4.84-26.63-5.49-40.57-.61-12.84-3.87-25.39-6.13-38.05-3.78-21.17-4.75-42.75-5.14-64.25-.16-9.08-.17-18.46,3.34-26.83,6.59-15.71,23.69-24,39.88-29.33,7.74-2.54,15.88-4.86,22-10.29,6.27-5.61,9.53-13.85,11.53-22-10.91-21.5-25.09-42-43-58.13-6.73-6-13.92-11.63-19.6-18.65-3.46-4.29-6.33-9.07-10.15-13-9.56-9.93-24-13.67-37.76-14.22-4.25-.17-8.56-.09-12.68-1.15-11.82-3-19.35-14.55-30-20.53a35.3,35.3,0,0,0-24.37-3.74c-6,1.25-12.14,4.81-13.49,10.73-.75,3.33.17,6.77.52,10.16,1.08,10.43-3.25,20.65-8.49,29.73C661,414.32,630.21,439.61,615.89,474.28Z",
    transform: "translate(-104.53 -50.34)",
    fill: "#6ba6c7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M721,274.38a101,101,0,1,1-46.87-85.29A101,101,0,0,1,721,274.38Z",
    transform: "translate(-104.53 -50.34)",
    fill: "#be6f72"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1062,726.16V679.38H176.66q2.49,3.66,5.05,7.24a31.43,31.43,0,0,0,5.23,8.39,30.37,30.37,0,0,0,3.8,3.65c19.2,24.45,41.06,45.21,65.1,60.92a208.26,208.26,0,0,0,43.69,21.8h734.64Z",
    transform: "translate(-104.53 -50.34)",
    fill: "#3f3d56"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M638.91,625.88c-13.57-1.08-27.68-4.46-40.46.22a58.64,58.64,0,0,0-12.31,6.72A221,221,0,0,0,548.24,665c-3.29,3.49-6.51,7.17-8.53,11.53-2.85,6.15-3.1,13.16-5,19.67-1.09,3.73-2.75,7.51-2.09,11.34s5.08,7.26,8.39,5.22h0a7.34,7.34,0,0,0,7.51,8.46,24.78,24.78,0,0,0,14-4.93h0a4.74,4.74,0,0,0,5,4.23c8.67-.57,16.93-5,24.35-9.84,8.71-5.64,17.36-12.06,27.56-14a44.69,44.69,0,0,0-16.15,12.49c-1.67,2.05-3.23,4.45-1.39,7.62a8.89,8.89,0,0,0,4.78,3.77c11.42,4,23.83-2.62,31.45-11.8,3.07-3.71,5.78-8,10-10.25,6.79-3.65,15.16-1.09,22.8-2.15,8.48-1.16,15.61-6.69,23.4-10.26,10.37-4.74,21.93-6,33-8.82a6,6,0,0,0,3.48-1.8,6.21,6.21,0,0,0,.85-3.84,286,286,0,0,0-3.09-40.92,14.25,14.25,0,0,0-1.95-6.18c-2.18-3.1-6.32-4-10.05-4.62-6-1-12.73-3.24-18.77-3.22-5.8,0-11.39,3.28-16.92,4.89A117.35,117.35,0,0,1,638.91,625.88Z",
    transform: "translate(-104.53 -50.34)",
    fill: "#be6f72"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M702.17,607.85a71,71,0,0,0-40.26,18c12.47-3.15,25.89-6.26,37.91-1.7a31.62,31.62,0,0,1,1.66,58.44c2.43,2.73,6,4.07,9.55,5.1,25.65,7.48,53.11,3,79.34-2.1,4.8-.93,10-2.16,12.93-6.11,2.61-3.57,2.53-8.38,2.3-12.81-.67-12.79-1.78-26-7.58-37.39-7.86-15.46-21.51-21.22-37.95-19.43C740.73,611.91,721.53,605.89,702.17,607.85Z",
    transform: "translate(-104.53 -50.34)",
    fill: "#e3e8f4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M865.37,444c8.29,7.89,14.27,17.85,19.76,27.89a462.25,462.25,0,0,1,42.42,107.74c.94,3.69,1.87,7.48,4.07,10.59,3.2,4.51,8.63,7,12.12,11.26,4.19,5.18,5,12.48,3.62,19s-4.67,12.47-8,18.24c-9.11,15.78-19.86,32.07-36.59,39.28-7,3-14.65,4.24-22.22,5.23A436.14,436.14,0,0,1,794.77,686c5-5.8,5.48-14.36,3.71-21.81s-5.46-14.28-8-21.49c-2-5.63-3.41-11.63-6.92-16.47a33.57,33.57,0,0,0-9.4-8.27A68.07,68.07,0,0,0,747,608c7.17-5.6,16.46-7.46,25.2-10s17.88-6.44,22.46-14.3c2.75-4.71,3.51-10.3,3.88-15.74a133.44,133.44,0,0,0-5.64-48.48c-3.22-10.43-7.78-21.33-5-31.87,1.42-5.32,4.61-10,7.74-14.48,6.1-8.8,12.42-17.81,21.32-23.75,7.68-5.13,16.81-7.54,25.95-8.18C849.76,440.75,860.17,439.09,865.37,444Z",
    transform: "translate(-104.53 -50.34)",
    fill: "#6ba6c7"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M505.52,750.5c-.08,10.44-28.47,22-61.32,22s-60.27-11.53-60.71-22c-1.53-36.31,27.85-15.87,60.71-15.87S505.82,708.7,505.52,750.5Z",
    transform: "translate(-104.53 -50.34)",
    fill: "#3f3d56"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M505.52,750.5c-.08,10.44-28.47,22-61.32,22s-60.27-11.53-60.71-22c-1.53-36.31,27.85-15.87,60.71-15.87S505.82,708.7,505.52,750.5Z",
    transform: "translate(-104.53 -50.34)",
    opacity: 0.2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M503.69,734.63c0,10.45-26.64,22-59.49,22s-59.49-11.52-59.49-22,26.63-15.86,59.49-15.86S503.69,724.19,503.69,734.63Z",
    transform: "translate(-104.53 -50.34)",
    fill: "#3f3d56"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M503.69,734.63c0,10.45-26.64,22-59.49,22s-59.49-11.52-59.49-22,26.63-15.86,59.49-15.86S503.69,724.19,503.69,734.63Z",
    transform: "translate(-104.53 -50.34)",
    fill: "#fff",
    opacity: 0.1
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M492.09,730.51c-.06,8.15-22.2,17.13-47.83,17.13s-47-9-47.36-17.13c-1.19-28.32,21.73-12.38,47.36-12.38S492.33,697.91,492.09,730.51Z",
    transform: "translate(-104.53 -50.34)",
    fill: "#3f3d56"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M492.09,730.51c-.06,8.15-22.2,17.13-47.83,17.13s-47-9-47.36-17.13c-1.19-28.32,21.73-12.38,47.36-12.38S492.33,697.91,492.09,730.51Z",
    transform: "translate(-104.53 -50.34)",
    opacity: 0.2
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M490.66,716.12c0,9.11-20.77,19.15-46.4,19.15s-46.41-10-46.41-19.15,20.78-13.82,46.41-13.82S490.66,707,490.66,716.12Z",
    transform: "translate(-104.53 -50.34)",
    fill: "#3f3d56"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M490.66,716.12c0,9.11-20.77,19.15-46.4,19.15s-46.41-10-46.41-19.15,20.78-13.82,46.41-13.82S490.66,707,490.66,716.12Z",
    transform: "translate(-104.53 -50.34)",
    fill: "#fff",
    opacity: 0.1
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M333.05,776.52s8.78-9.68,10.29-20.56-42.9-27.59-42.9-27.59-15.4,9-15.92,17.43C284.52,745.8,314,777.48,333.05,776.52Z",
    transform: "translate(-104.53 -50.34)",
    fill: "#3f3d56"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M333.05,776.52s8.78-9.68,10.29-20.56-42.9-27.59-42.9-27.59-15.4,9-15.92,17.43C284.52,745.8,314,777.48,333.05,776.52Z",
    transform: "translate(-104.53 -50.34)",
    opacity: 0.2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 307.98,
    cy: 762.13,
    rx: 9.66,
    ry: 28.78,
    transform: "translate(-608.52 583.7) rotate(-59.03)",
    fill: "#3f3d56"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 307.98,
    cy: 762.13,
    rx: 9.66,
    ry: 28.78,
    transform: "translate(-608.52 583.7) rotate(-59.03)",
    fill: "#fff",
    opacity: 0.1
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "239.43 702.29 264.69 660.18 239 638.36 218.97 634.61 212.72 645.88 195.14 678.5 239.43 702.29",
    fill: "#3f3d56"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "239.43 702.29 264.69 660.18 239 638.36 218.97 634.61 212.72 645.88 195.14 678.5 239.43 702.29",
    fill: "#fff",
    opacity: 0.1
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M369.56,714.67s17.06-18.13,12.68-27.93S354.73,657.3,340,660.29,322.91,685,322.91,685Z",
    transform: "translate(-104.53 -50.34)",
    fill: "#3f3d56"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M369.56,714.67s17.06-18.13,12.68-27.93S354.73,657.3,340,660.29,322.91,685,322.91,685Z",
    transform: "translate(-104.53 -50.34)",
    opacity: 0.2
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M175.51,635l130.67,79.48s12.42-1.61,11.07-18.24L187.83,615.9A13.39,13.39,0,0,0,179,614c-3.54.48-7.73,1.77-9.09,5.14a11.39,11.39,0,0,0-.72,2.67A13.19,13.19,0,0,0,175.51,635Z",
    transform: "translate(-104.53 -50.34)",
    fill: "#3f3d56"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M175.51,635l130.67,79.48s12.42-1.61,11.07-18.24L187.83,615.9A13.39,13.39,0,0,0,179,614c-3.54.48-7.73,1.77-9.09,5.14a11.39,11.39,0,0,0-.72,2.67A13.19,13.19,0,0,0,175.51,635Z",
    transform: "translate(-104.53 -50.34)",
    opacity: 0.2
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M343.94,758.56a3.21,3.21,0,0,0,2.93-2.42c.64-2.25-.53-4.41-1.76-6.21a33.36,33.36,0,0,0-8.1-8.28c-5.32-3.85-10.48-8.19-16.5-11a50.41,50.41,0,0,0-10.88-3.43,37,37,0,0,0-8.56-.94,2.52,2.52,0,0,0-1.55,4.45l0,0a12.71,12.71,0,0,0,4.38,1.84c7.79,2.29,15,6.26,21.75,10.77a68.29,68.29,0,0,1,10.17,8C337.9,753.4,340.56,758.64,343.94,758.56Z",
    transform: "translate(-104.53 -50.34)",
    fill: "#3f3d56"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M343.94,758.56a3.21,3.21,0,0,0,2.93-2.42c.64-2.25-.53-4.41-1.76-6.21a33.36,33.36,0,0,0-8.1-8.28c-5.32-3.85-10.48-8.19-16.5-11a50.41,50.41,0,0,0-10.88-3.43,37,37,0,0,0-8.56-.94,2.52,2.52,0,0,0-1.55,4.45l0,0a12.71,12.71,0,0,0,4.38,1.84c7.79,2.29,15,6.26,21.75,10.77a68.29,68.29,0,0,1,10.17,8C337.9,753.4,340.56,758.64,343.94,758.56Z",
    transform: "translate(-104.53 -50.34)",
    opacity: 0.2
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M364.8,717.89s12.82.31,2.21-12.58-29.59-25.68-43.1-22.79c0,0-5.6,4.64-.76,5.44,4.59.76,26,5,35.84,16.93a25.55,25.55,0,0,0,3.59,3.54C364.89,710.31,368,713.87,364.8,717.89Z",
    transform: "translate(-104.53 -50.34)",
    fill: "#3f3d56"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M364.8,717.89s12.82.31,2.21-12.58-29.59-25.68-43.1-22.79c0,0-5.6,4.64-.76,5.44,4.59.76,26,5,35.84,16.93a25.55,25.55,0,0,0,3.59,3.54C364.89,710.31,368,713.87,364.8,717.89Z",
    transform: "translate(-104.53 -50.34)",
    opacity: 0.2
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 361.03,
    cy: 674.65,
    rx: 9.66,
    ry: 28.78,
    transform: "translate(-507.76 586.73) rotate(-59.03)",
    fill: "#3f3d56"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 361.03,
    cy: 674.65,
    rx: 9.66,
    ry: 28.78,
    transform: "translate(-507.76 586.73) rotate(-59.03)",
    fill: "#fff",
    opacity: 0.1
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M301.07,686.18a14.3,14.3,0,0,1-7.14,11.34c-6.71,3.58-16.13.39-19.29-6.53-1.64-3.6-1.67-7.64-2-11.61a38.09,38.09,0,0,0-.52-3.86c-1-5.15-5.26-10.62-10.41-9.6-4.25.83-6.49,5.6-7,9.9a32.53,32.53,0,0,0-.2,3.56c0,1.24.05,2.48.12,3.72.14,2.54.36,5.09.35,7.63,0,5-1.08,10.31-4.69,13.74-4.38,4.17-11.1,4.36-17.16,4.29-14.79-.15-31.25-1-42.38-10.1a30.37,30.37,0,0,1-3.8-3.65,31.43,31.43,0,0,1-5.23-8.39,38.8,38.8,0,0,1-2.27-7.24c-1.66-7.75-1.29-16.2.07-24.06.88-5.14,2.58-10.77,6.34-14.05a11.41,11.41,0,0,1,3-1.89c1.8-.76,3.84-1,5.41-2.19s2.59-3.35,4.25-4.65c3.33-2.61,8.39-1.49,12.29-2.37h0l.17,0,.21-.06c4.21-1,8.1-3.3,12.07-5,1.71-.73,3.42-1.43,5.14-2.05a29.56,29.56,0,0,1,13.5-2c15,1.71,33,10.81,43.27,21.73a25.27,25.27,0,0,1,5.78,8.86,32.82,32.82,0,0,1,1.38,8.59c.27,4.11.49,8.21,2.53,11.72,1.24,2.12,3.06,3.85,4.35,6a11.36,11.36,0,0,1,.78,1.51A13.73,13.73,0,0,1,301.07,686.18Z",
    transform: "translate(-104.53 -50.34)",
    fill: "#be6f72"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M268.08,636.82c6.11,3.16,12.12,6.73,16.92,11.65s8.34,11.37,8.62,18.25a86.25,86.25,0,0,0,10.73-16.51c2.32-4.65,4.23-10.15,2.17-14.93a16.64,16.64,0,0,0-4.07-5.3c-9-8.52-21.1-13.23-33.34-15.16-13.23-2.09-39.66-6.65-41.69,12.61C242.24,626.73,254.84,630,268.08,636.82Z",
    transform: "translate(-104.53 -50.34)",
    fill: "#e3e8f4"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M432,390.56c-9.79,4.23-21.25,1.24-31.6,3.8-7.64,1.89-14.21,6.68-20.41,11.53-12.36,9.66-24.54,20.46-31.15,34.69-2.16,4.66-3.7,9.61-6.29,14-4.19,7.16-10.88,12.49-17.85,17-17.81,11.48-38.49,18.66-54.34,32.72-6.78,6-12.49,13.12-17.8,20.45-6.24,8.6-12.21,18.2-12.33,28.82,0,4.16.82,8.38,0,12.47-1.76,9.15-11,14.83-15.17,23.17-4,7.95-3.05,17.77-7.5,25.45-2.92,5-8.21,10-6.54,15.52,12.26-9.21,27-13,42-10,7.51,1.49,14.52,4.84,21.24,8.51,7.79,4.26,15.47,9.1,21.1,16s9,16.08,7,24.73c8.11-4,12.91-12.54,16.24-20.94S324.47,631.11,330,624c2.85-3.67,6.39-6.72,9.76-9.91,18.71-17.73,32.2-40.13,45.44-62.24q20.48-34.18,40.94-68.4c3.78-6.33,7.58-12.7,10.31-19.54C445.62,440.91,439.68,414.05,432,390.56Z",
    transform: "translate(-104.53 -50.34)",
    fill: "#6ba6c7"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 898.7,
    cy: 634.73,
    rx: 57.01,
    ry: 10.96,
    fill: "#6ba6c7"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 897.74,
    cy: 630.08,
    rx: 6.64,
    ry: 8.69,
    fill: "#3f3d56"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 897.74,
    cy: 619.45,
    rx: 6.64,
    ry: 8.69,
    fill: "#3f3d56"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 897.74,
    cy: 608.83,
    rx: 6.64,
    ry: 8.69,
    fill: "#3f3d56"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 897.74,
    cy: 598.21,
    rx: 6.64,
    ry: 8.69,
    fill: "#3f3d56"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 897.74,
    cy: 587.59,
    rx: 6.64,
    ry: 8.69,
    fill: "#3f3d56"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 897.74,
    cy: 576.97,
    rx: 6.64,
    ry: 8.69,
    fill: "#3f3d56"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 897.74,
    cy: 566.35,
    rx: 6.64,
    ry: 8.69,
    fill: "#3f3d56"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M1027.13,544a32.2,32.2,0,0,0,2.47-3.63l-17.44-2.87,18.86.14a31.86,31.86,0,0,0,.61-25.19l-25.31,13.13,23.34-17.16A31.8,31.8,0,1,0,977.14,544a32.4,32.4,0,0,0-3.62,5.8l22.64,11.77L972,553.46a31.82,31.82,0,0,0,5.12,29.86,31.8,31.8,0,1,0,50,0,31.82,31.82,0,0,0,0-39.32Z",
    transform: "translate(-104.53 -50.34)",
    fill: "#6ba6c7"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M970.34,563.66a31.67,31.67,0,0,0,6.8,19.66,31.8,31.8,0,1,0,50,0C1031.39,577.91,970.34,560.09,970.34,563.66Z",
    transform: "translate(-104.53 -50.34)",
    opacity: 0.1
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M570,230.28c7,2.7,13.83,6.58,21.34,7.09,9.53.64,18.53-4.22,28-5.56,17.35-2.45,33.82,7,50.12,13.42s37.3,9.08,49.25-3.73c10.15-10.89,8.75-29,.59-41.4s-21.49-20.42-34.67-27.33c-14.54-7.62-29.7-14.55-45.89-17.24-34.36-5.69-69.27,8.52-97.78,28.53-9.46,6.64-18.81,14.39-23.33,25-2.56,6-3.36,13.68-1.13,19.93,3.66,10.28,6.06,9.06,13.65,6.38C544.65,230.27,553.22,223.86,570,230.28Z",
    transform: "translate(-104.53 -50.34)",
    fill: "#3f3d56"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransparencyAndComplianceSecondary);
export default __webpack_public_path__ + "static/media/transparency-and-compliance-secondary.e28ce0baaa9f5b3d23e01be1c817074a.svg";
export { ForwardRef as ReactComponent };